import { render, staticRenderFns } from "./borclulistesi.vue?vue&type=template&id=34ef17b8&"
import script from "./borclulistesi.vue?vue&type=script&lang=js&"
export * from "./borclulistesi.vue?vue&type=script&lang=js&"
import style0 from "./borclulistesi.vue?vue&type=style&index=0&id=34ef17b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports